import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/disclaimer")({
  head: () => ({
    meta: [
      { title: "Risk Disclaimer — ForexMind AI" },
      { name: "description", content: "Forex trading risk disclaimer for ForexMind AI signals and analysis." },
      { name: "robots", content: "index,follow" },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "ForexMind AI" },
      { property: "og:title", content: "Risk Disclaimer — ForexMind AI" },
      { property: "og:description", content: "Forex trading risk disclaimer for ForexMind AI signals and analysis." },
      { property: "og:url", content: "https://forexmind.ai/disclaimer" },
      { property: "og:image", content: "https://forexmind.ai/og-image.png" },
      { property: "og:image:secure_url", content: "https://forexmind.ai/og-image.png" },
      { property: "og:image:type", content: "image/png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Risk Disclaimer — ForexMind AI" },
      { name: "twitter:description", content: "Forex trading risk disclaimer for ForexMind AI signals and analysis." },
      { name: "twitter:image", content: "https://forexmind.ai/og-image.png" },
    ],
    links: [{ rel: "canonical", href: "https://forexmind.ai/disclaimer" }],
  }),
  component: DisclaimerPage,
});

function DisclaimerPage() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-16 text-foreground">
      <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Back to home</Link>
      <h1 className="mt-6 text-3xl font-bold">Risk Disclaimer</h1>
      <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
        <p className="rounded-lg border border-destructive/40 bg-destructive/10 p-4 text-foreground">
          <strong>ForexMind AI provides educational signals for informational purposes only. This is not financial advice. Forex trading involves significant risk of loss. Past performance does not guarantee future results. Never trade with money you cannot afford to lose.</strong>
        </p>
        <h2 className="text-lg font-semibold text-foreground">No financial advice</h2>
        <p>All content, signals, analysis, and commentary delivered through ForexMind AI are produced for educational and informational purposes. Nothing on this platform constitutes a personal recommendation, financial advice, investment advice, tax advice, or solicitation to buy or sell any financial instrument.</p>
        <h2 className="text-lg font-semibold text-foreground">Trading risk</h2>
        <p>Foreign exchange (forex), CFD, and derivatives trading carry a high level of risk and may not be suitable for every investor. Leverage can work against you as well as for you. Before deciding to trade, you should carefully consider your investment objectives, level of experience, and risk appetite. You could sustain a loss of some or all of your initial investment.</p>
        <h2 className="text-lg font-semibold text-foreground">No guarantees</h2>
        <p>AI-generated forecasts, confluence scores, and agent reasoning are model outputs based on historical and live market data. They may be incomplete, inaccurate, or out of date. ForexMind AI makes no warranty of any kind regarding the accuracy, completeness, or usefulness of any information provided.</p>
        <h2 className="text-lg font-semibold text-foreground">Your responsibility</h2>
        <p>You are solely responsible for your own investment decisions. Seek advice from a licensed financial advisor before making any trading decision. By using this platform you acknowledge and accept all of the above.</p>
      </div>
    </main>
  );
}
